module.exports = __webpack_public_path__ + "static/media/coffee_A0_Path_4_pattern@2x_cut2.aedcb32f.png";